import type { Response, Request } from 'express';
import { getFaq, extractSbtHeaders } from '@sbt-web/network/server';
import { HTTPStatusCode, NetError, Faq } from '@sbt-web/network/types';
import { HADES_PATH } from '@/shared/constants';
import {
  registerSeoError,
  registerSeoTimeoutError,
} from '@/tools/errorHelpers';
import { FaqRequestParams } from './types';
import { encodeObjectToQueryString } from './utils/encodeObjectToQueryString';

export const fetchFaqResponseHandler = async (
  params: FaqRequestParams,
  req: Request,
  res: Response | undefined
): Promise<Faq | null> => {
  const queryString = encodeObjectToQueryString(params);

  if (!queryString) {
    return null;
  }

  try {
    const sbtHeaders = extractSbtHeaders(req);
    const { status, body } = await getFaq(
      process.env.PITO_BASE_URL ?? HADES_PATH,
      queryString,
      sbtHeaders
    );

    if (status !== HTTPStatusCode.OK) {
      return null;
    }

    return body;
  } catch (error: unknown) {
    if (error instanceof NetError) {
      if (error.cause.status === HTTPStatusCode.RequestTimeout) {
        registerSeoTimeoutError(res, 'PITO');
      } else {
        registerSeoError(res, 'PITO', error);
      }
    }

    return null;
  }
};
